<mat-dialog-title><b>Partner Değiştirme</b></mat-dialog-title>
<br />

<mat-dialog-content style="max-height: none; height: auto; overflow-y: hidden">
  <div style="display: flex; flex-direction: column">
    <mat-form-field
      class="form-element"
      style="width: 475px"
      appearance="outline"
    >
      <mat-label>{{ "Partner Listesi" }}</mat-label>
      <mat-select
        [(ngModel)]="selectedPartner"
        name="branch"
        (selectionChange)="getPartnerAggrementList()"
      >
        <ng-container *ngFor="let partner of partnerListData">
          <mat-option
            *ngIf="partner.identity != oldPartnerId"
            [value]="partner.identity"
          >
            {{ partner.title.substring(0, 30) }} - {{ partner.identity }}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
    <mat-form-field
      *ngIf="moveCounter"
      class="form-element"
      style="width: 475px"
      appearance="outline"
    >
      <mat-label>{{ "Partner Sözleşme Listesi" }}</mat-label>
      <mat-select [(ngModel)]="selectedPartnerAggrement">
        <mat-option
          *ngFor="let partnerAggrement of partnerAggrementListData"
          [value]="partnerAggrement.id"
        >
          {{ partnerAggrement.code }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <span>&nbsp;</span>

    <mat-checkbox aria-label="Aktif/Pasif" [(ngModel)]="moveCounter">
      <!-- (change)="isActiveChange($event)" -->
      Kontörünü Taşı
    </mat-checkbox>
    <mat-checkbox aria-label="Aktif/Pasif" [(ngModel)]="moveLedger">
      <!-- (change)="isActiveChange($event)" -->
      Defteri Taşı
    </mat-checkbox>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" style="padding: 0">
  <button mat-raised-button (click)="changeClick()" color="primary">
    Kaydet
  </button>
  <button mat-raised-button matDialogClose color="primary">Kapat</button>
</mat-dialog-actions>

<div id="ej2Toast" #toast></div>
